import { defineStore } from 'pinia'

export interface Track {
  title: string
  subtitle: string
  src: string
  cover?: string
}

export const useMedia = defineStore('media', {
  state: () => ({
    tracks: [] as Track[],
    currentIndex: 0,
    isPlaying: false,
    playerState: false,
    audioEl: null as HTMLAudioElement | null,
    isBuffering: false,
    isVisible: false
  }),

  actions: {
    setTracks(tracks: Track[]) {
      this.tracks = tracks
    },

    setAudioEl(el: HTMLAudioElement | null) {
      this.audioEl = el
    },

    setVisibility(state: boolean) {
      this.isVisible = state
    },

    playTrack(index: number) {
      if (index < 0 || index >= this.tracks.length) return
      this.currentIndex = index
      this.playerState = true
      this.isVisible = true
      this.setPlaying(true)
    },

    setBuffering(state: boolean) {
      this.isBuffering = state
    },

    togglePlay() {
      this.setPlaying(!this.isPlaying)
    },

    setPlaying(state: boolean) {
      this.isPlaying = state
      if (this.audioEl) {
        if (state) {
          this.audioEl.play().catch(e => console.warn('Play-Error:', e))
        } else {
          this.audioEl.pause()
        }
      }
    },

    next() {
      if (this.tracks.length === 0) return
      this.currentIndex = (this.currentIndex + 1) % this.tracks.length
      this.setPlaying(true)
    },

    prev() {
      if (this.tracks.length === 0) return
      this.currentIndex = (this.currentIndex - 1 + this.tracks.length) % this.tracks.length
      this.setPlaying(true)
    },
  },
})
